import React, { FormEvent } from 'react';
import GlobalProps from '../globalProps';
import classnames from 'classnames';

import { Icon } from '../Icon/Icon';
import './Pagination.css';
import { t } from '../../locales/translate';

interface Props extends GlobalProps {
  page: number;
  perPage?: number;
  totalCount: number;
  customText?: string;
  setPage?: (page: number) => void;
  setPerPage?: (perPage: number) => void;
}

export function Pagination({
  className,
  style,
  page,
  perPage = 10,
  totalCount,
  customText,
  setPage,
  setPerPage,
}: Props): JSX.Element {
  const MAX_PAGES = Math.ceil(totalCount / perPage);
  const START_RANGE = Math.min(page, MAX_PAGES) * perPage + 1;
  const END_RANGE = Math.min((page + 1) * perPage, totalCount);

  function perPageChange(e: FormEvent<HTMLSelectElement>): void {
    const newPerPage = Number(e.currentTarget.value);
    if (setPerPage) {
      setPerPage(newPerPage);
    }
  }

  function next(): void {
    if (page < MAX_PAGES) {
      if (setPage) {
        setPage(page + 1);
      }
    }
  }

  function previous(): void {
    if (page > 0) {
      if (setPage) {
        setPage(page - 1);
      }
    }
  }

  return (
    <div className={classnames('pagination', className)} style={style}>
      <div className="pagination__select-info-text">{customText || t.component.pagination.linesPerPage}</div>
      {setPerPage && (
        <div className="pagination__select-wrapper">
          <select name="pages" onChange={perPageChange} value={perPage} className="pagination__select">
            {[10, 20, 50, 100].map((value) => (
              <option value={value} key={value}>
                {value}
              </option>
            ))}
          </select>
        </div>
      )}
      {totalCount > 0 && (
        <>
          <div className="pagination__pagecount">
            {t.component.pagination.outOf(`${START_RANGE} - ${END_RANGE}`, String(totalCount))}
          </div>
          <div className="pagination__arrows">
            <Icon
              className={classnames('pagination__btn', 'pagination__btn--previous', {
                'pagination__btn--disabled': page <= 0,
              })}
              name="icon-arrow--sm"
              onClick={previous}
            />

            <Icon
              name="icon-arrow--sm"
              onClick={next}
              className={classnames('pagination__btn--next', 'pagination__btn', {
                'pagination__btn--disabled': page + 1 >= MAX_PAGES,
              })}
            />
          </div>
        </>
      )}
    </div>
  );
}
